import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITabsCounterProps from "./type";
import stylesheet, {
    getTabsCounterColors,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getBadgeColors
} from "../../../badge/stylesheet";
import {
    getTabsCountText
} from "../../util";
import Badge from "../../../badge";
import Text from "../../../text";

const TabsCounter: FC<ITabsCounterProps> = ({
    customLocalize,
    customTheme,
    isDisabled,
    isSelected,
    countType,
    variant,
    count,
    size
}) => {
    const {
        shapeConfigs,
        iconSizes,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const currentCounter = getTabsCounterColors({
        isDisabled,
        isSelected,
        countType,
        variant,
        colors
    });

    const currentColors = getBadgeColors({
        customColor: currentCounter.customColor,
        type: currentCounter.type,
        variant: "tonal",
        isDisabled,
        colors
    });

    const {
        chip: chipDynamicStyle
    } = useStyles({
        containerColor: currentColors.containerColor,
        borderColor: currentColors.borderColor,
        shapeConfigs,
        iconSizes,
        radiuses,
        borders
    });

    const text = getTabsCountText({
        locale: activeLocale,
        count
    });

    if(size !== "small") {
        return <Badge
            customColor={currentCounter.customColor}
            titleStyle={stylesheet.title}
            type={currentCounter.type}
            customTheme={customTheme}
            isDisabled={isDisabled}
            spreadBehaviour="free"
            size="small"
            title={text}
        />;
    }

    return <View
        style={[
            stylesheet.chip,
            chipDynamicStyle
        ]}
    >
        <Text
            customColor={currentColors.titleColor}
            customTheme={customTheme}
            style={stylesheet.title}
            variant="labelSmallSize"
            numberOfLines={1}
        >
            {text}
        </Text>
    </View>;
};
export default TabsCounter;
